import { type UserResponse, useUser } from "./useUser";

type Message = UserResponse["messages"][0];

export const useNotifications = () => {
    const { data: userData, isLoading, error } = useUser();

    return {
        data: userData?.messages || ([] as Message[]),
        isLoading,
        error,
        isError: !!error,
        isSuccess: !!userData && !error,
    };
};
